/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { InquirySellerAgencyBranchResponseDto } from './inquirySellerAgencyBranchResponseDto';

export interface InquirySellerAgencyResponseDto {
  /** @nullable */
  name: string | null;
  /** @nullable */
  logoUrl: string | null;
  /** @nullable */
  branch: InquirySellerAgencyBranchResponseDto | null;
}
